export default __webpack_public_path__ + "static/avatar-andy-gray3-4cb3341da9cf5dba6ebe831c4d60b5a5.webp";